import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();
  const commonSwitchViewText = css`
    color: ${colors.ocean_depth_navy};
    font-size: 0.938rem;
    font-weight: 700;
    line-height: 1.25rem;
    text-transform: uppercase;
    letter-spacing: 0.015rem;
  `;
  const focusVisibleStyles = css`
    outline: 2px solid ${colors.skip_yellow};
    border: 2px solid ${colors.border_black};
    padding: 0.25rem;
    text-decoration: none;
  `;

  return {
    filterviewContainer: css`
      font-family: FS Dillon;
      flex: 0 0 4rem;
      height: 4rem;
      min-height: 4rem;
      width: 100%;
      background-color: white;
      color: black;
      position: relative;
      z-index: 1201;
      display: flex;
      align-items: center;
      justify-content: space-between;
      -webkit-box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.26);
      -moz-box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.26);
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
      padding: 1rem 2rem;
      ${breakpoints.mm_m_l} {
        padding: 0 5rem;
      }
      ${breakpoints.mm_s_m} {
        padding: 0 3rem;
      }
      ${breakpoints.mm_xs_s} {
        padding: 0 1rem;
      }
      ${breakpoints.mm_xxs_xs} {
        padding: 0 0.75rem;
      }
      ${breakpoints.mm_xxs_m} {
        position: sticky;
        top: 0;
      }
    `,
    filterSwitch: css`
      all: unset;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 0.5rem;
      &:hover,
      &:focus:not(:focus-visible),
      &:active {
        span:first-of-type {
          text-decoration: underline;
        }
      }
      &:focus-visible:not(:hover) {
        ${focusVisibleStyles}
      }
    `,
    filterSwitchText: commonSwitchViewText,
    numOfFilters: css`
      height: 1.125rem;
      width: 1.125rem;
      color: ${colors.white};
      font-size: 0.625rem;
      line-height: 1.25rem;
      letter-spacing: 8%;
      background-color: ${colors.red};
      border-radius: 3.125rem;
      text-align: center;
    `,
    viewListOrMap: css`
      all: unset;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 0.5rem;
      &:hover,
      &:focus:not(:focus-visible),
      &:active {
        span {
          text-decoration: underline;
        }
      }
      &:focus-visible:not(:hover) {
        ${focusVisibleStyles}
      }
    `,
    filterViewText: commonSwitchViewText,
  };
};
